import React, { useState } from "react";
import styled from "styled-components";
import Theme from "../Theme";
import { Redirect } from "react-router-dom";
import UserEvent from "../analytics/UserEvent";
import ChwLogoBw from "./svg/ChwLogoBw";

function Header() {
  const [toHome, setToHome] = useState<boolean>(false);

  return (
    <Container>
      <StyledLogo onClick={e => setToHome(true)} />
      {toHome && <Redirect to="/" />}
      <Nav>
        <NavLink href="#" onClick={() => UserEvent("Nav Link1", "Nav Link")}>
          <NavLinkText>EN</NavLinkText>
        </NavLink>
        <NavLink href="#" onClick={() => UserEvent("E-Nav Link2", "Nav Link")}>
          <NavLinkText>DE</NavLinkText>
        </NavLink>
        <NavButton href="" onClick={() => UserEvent("Login", "Nav Button")}>
          Anmelden
        </NavButton>
      </Nav>
    </Container>
  );
}

export default Header;

const Container = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  box-sizing: border-box;
  color: ${Theme.colors.dark};
  background-color: white;
  opacity: 0.98;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
  z-index: 5;

  @media screen and (max-width: 450px) {
    padding: 1rem 1rem;
  }
`;

const StyledLogo = styled(ChwLogoBw)`
  height: 2rem;
  flex-shrink: 0;
  padding-right: 2rem;
  cursor: pointer;
  color: ${Theme.colors.dark};
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: right;
`;

const NavLink = styled.a`
  display: flex;
  align-items: center;
  color: ${Theme.colors.dark};
  text-decoration: none;
  transition: border-bottom 0.3s ease-in;
  margin-right: 2rem;

  &:last-child {
    margin-right: 0;
  }

  @media screen and (max-width: 800px) {
    display: none;
  }
`;

const NavLinkText = styled.span`
  position: relative;
  padding-bottom: 0.3rem;
  &:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: ${Theme.colors.dark};
    transform: scaleX(0);
    transition: all 0.3s ease-in-out 0s;
  }

  &:hover:before {
    visibility: visible;
    transform: scaleX(1);
  }
`;

const NavButton = styled.a`
  font-size: 1rem;
  position: relative;
  color: ${Theme.colors.dark};
  text-decoration: none;
  border: 1px solid ${Theme.colors.dark};
  padding: 0.4rem 1.7rem;
  border-radius: 6px;
  transition: background-color 0.3s ease-in-out 0s, color 0.3s ease-in-out 0s;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: ${Theme.colors.dark};
      color: ${Theme.colors.light};
    }
  }

  @media screen and (max-width: 450px) {
    display: none;
  }
`;
